var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true","focusable":"false"},domProps:{"innerHTML":_vm._s(_vm.markup)}})
}
var staticRenderFns = []

export { render, staticRenderFns }